<!--
  @description: 微信通知服务 - 用户列表页面
  @author: system
  @date: 2026-06-02
  @note: 管理公众号关注用户，支持手动发送通知
-->
<template>
  <div class="user-list-container">
    <!-- 页面标题 -->
    <!-- <div class="page-header">
      <h2 class="page-title">
        <i class="el-icon-user"></i>
        用户列表
      </h2>
      <p class="page-desc">公众号关注用户的管理和通知发送</p>
    </div>-->

    <!-- 筛选查询框 -->
    <div class="filter-container">
      <el-form :inline="true">
        <el-button type="primary" size="small" icon="el-icon-plus" v-waves @click="handleAdd">新增用户</el-button>
        <el-form-item label="公众号:" style="margin:0 10px" size="small">
          <el-select
            v-model="listQuery.appid"
            placeholder="请选择公众号"
            clearable
            filterable
            style="width: 200px;"
          >
            <el-option
              v-for="item in gzhList"
              :key="item.appid"
              :label="item.account_name"
              :value="item.appid"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用户小程序openid:" style="margin:0 10px" size="small">
          <el-input v-model="listQuery.openid" placeholder="请输入" clearable style="width: 200px;"></el-input>
        </el-form-item>
        <el-form-item label="用户公众号openid:" style="margin:0 10px" size="small">
          <el-input
            v-model="listQuery.gzh_openid"
            placeholder="请输入"
            clearable
            style="width: 200px;"
          ></el-input>
        </el-form-item>
        <el-form-item label="用户昵称:" style="margin:0 10px" size="small">
          <el-input v-model="listQuery.user_name" placeholder="请输入" clearable style="width: 200px;"></el-input>
        </el-form-item>
        <el-button type="primary" @click="search" size="small" icon="el-icon-search" v-waves>搜索</el-button>
      </el-form>
    </div>

    <!-- 表格列表 -->
    <div class="table-container">
      <ElTable
        :columns="listHeader"
        :tableData="tableData"
        :loading="loading"
        :total="listQuery.total"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      >
        <!-- 公众号显示 -->
        <!-- <template slot="appid" slot-scope="{ row }">
          <el-tag type="success" effect="dark" size="mini">
            {{
              arrayByIdToNameStr({
                ArrayData: gzhList,
                ID: row.appid,
                id_key:'appid',
                name_key:'account_name'
              })
            }}
          </el-tag>
        </template>-->

        <!-- 用户昵称 -->
        <template slot="user_name" slot-scope="{ row }">{{ row.user_name ? row.user_name : '-' }}</template>

        <!-- openid -->
        <template slot="openid" slot-scope="{ row }">
          <span class="code-text">{{ row.openid ? row.openid : '-' }}</span>
        </template>

        <template slot="gzh_openid" slot-scope="{ row }">
          <span class="code-text">{{ row.gzh_openid ? row.gzh_openid : '-' }}</span>
        </template>

        <!-- 二维码图片 -->
        <template slot="gzh_img" slot-scope="{ row }">
          <el-image
            class="elImage"
            :src="row.gzh_img"
            :preview-src-list="[row.gzh_img]"
            v-if="row.gzh_img"
          ></el-image>
          <div v-else class="no-image">暂未上传</div>
        </template>

        <!-- 操作按钮 -->
        <template slot="operation" slot-scope="{ row }">
          <div class="operation">
            <el-button size="mini" type="text" @click="handleEdit(row)" primary>编辑</el-button>
            <el-button
              size="mini"
              type="text"
              @click="handleSend(row)"
              primary
              style="color: #67C23A;"
            >发送通知</el-button>
            <!-- <el-button size="mini" type="text" @click="handleCopy(row)" primary>复制用户公众号openid</el-button> -->
            <el-button size="mini" type="text" style="color: #F56C6C;" @click="handleDelete(row)">删除</el-button>
          </div>
        </template>
      </ElTable>
    </div>

    <!-- 新增/编辑用户抽屉 -->
    <CommonDrawer
      :visible.sync="dialogFormVisible"
      :title="inputTypeName"
      :close-on-click-modal="false"
      @confirm="save"
      @cancel="dialogFormVisible = false"
    >
      <el-form ref="form" :model="dialogForm" label-width="150px" class="drawer-form">
        <el-form-item label="选择公众号" required>
          <el-select
            v-model="dialogForm.appid"
            placeholder="请选择公众号"
            clearable
            filterable
            style="width: 100%;"
            :disabled="!!dialogForm.id"
          >
            <el-option
              v-for="item in gzhList"
              :key="item.appid"
              :label="item.account_name"
              :value="item.appid"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用户公众号openid" required>
          <el-input
            v-model="dialogForm.gzh_openid"
            clearable
            placeholder="用户公众号openid"
            :disabled="!!dialogForm.id"
          ></el-input>
        </el-form-item>
        <el-form-item label="openid">
          <el-input v-model="dialogForm.openid" clearable placeholder="请输入openid"></el-input>
        </el-form-item>
        <el-form-item label="昵称">
          <el-input v-model="dialogForm.user_name" clearable placeholder="请输入用户昵称"></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="dialogForm.phone" clearable placeholder="请输入用户手机号"></el-input>
        </el-form-item>
      </el-form>
    </CommonDrawer>

    <!-- 发送通知抽屉 -->
    <CommonDrawer
      :visible.sync="drawerVisible"
      title="发送通知"
      size="50%"
      :showFooter="false"
      @close="handleDrawerClose"
    >
      <el-form ref="sendForm" :model="sendForm" label-width="150px" class="send-form">
        <el-form-item label="所属公众号" required>
          <el-input clearable v-model="sendForm.account_name" disabled></el-input>
        </el-form-item>
        <el-form-item label="用户公众号openid" required>
          <el-input clearable v-model="sendForm.gzh_openid" disabled placeholder="接收者公众号openid"></el-input>
        </el-form-item>
        <el-form-item label="选择模版" required>
          <el-select
            v-model="sendForm.template_id"
            placeholder="请选择消息模版"
            clearable
            filterable
            style="width:100%"
            @change="changeTemplate"
          >
            <el-option
              v-for="(item, index) in filteredTemplateList"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="模版内容" required v-if="sendForm.template_id">
          <div
            v-for="(item, index) in sendForm.template_msg_list"
            :key="index"
            class="template-field"
          >
            <div class="field-row">
              <el-tag type="info" size="mini" class="field-label">字段中文描述:</el-tag>
              <el-input
                size="mini"
                v-model="item.keyName"
                placeholder="请输入"
                class="field-input"
                disabled
              ></el-input>

              <el-tag type="info" size="mini" class="field-label">字段英文命名:</el-tag>
              <el-input
                size="mini"
                v-model="item.key"
                placeholder="请输入"
                class="field-input"
                disabled
              ></el-input>

              <el-tag type="success" size="mini" class="field-label">字段值:</el-tag>
              <el-input
                size="mini"
                v-model="item.value"
                placeholder="请输入发送的内容"
                class="field-value"
                type="textarea"
                :rows="1"
              ></el-input>
            </div>
          </div>
        </el-form-item>
        <el-form-item label>
          <el-button
            size="small"
            type="primary"
            icon="el-icon-s-promotion"
            :loading="sendLoading"
            :disabled="sendLoading"
            @click="sendNotification"
            v-waves
          >立即发送</el-button>
          <el-button size="small" @click="drawerVisible = false" :disabled="sendLoading">取消</el-button>
        </el-form-item>
      </el-form>
    </CommonDrawer>
  </div>
</template>

<script>
/**
 * @description 用户列表页面
 * @component UserList
 * @requires services/sendService/sendVisitor - 用户相关API
 * @requires services/sendService/sendAccount - 公众号相关API
 * @requires services/sendService/sendTemplate - 模版相关API
 * @requires services/sendService/wxSend - 发送通知API
 */
import {
  selectApi,
  updateApi,
  deleteApi,
  addApi
} from "@/services/sendService/sendVisitor";
import { selectApi as selectGzhListApi } from "@/services/sendService/sendAccount";
import { wxSendAPi } from "@/services/sendService/wxSend";
import { selectApi as selectTemplateApi } from "@/services/sendService/sendTemplate";
import ElTable from "@/components/elTable/index.vue";
import CommonDrawer from "@/components/drawer/index.vue";
import listHeader from "./listHeader";
import { mapState } from "vuex";
import { arrayByIdToNameStr } from "@/utils/arrayByIdToNameStr";

export default {
  name: "UserList",
  components: {
    ElTable,
    CommonDrawer
  },
  created() {
    // 页面创建时获取公众号列表、用户列表和模版列表
    this.getGzhList();
    this.getListData();
    this.getTemplateData();
  },
  data() {
    return {
      arrayByIdToNameStr,
      // 公众号列表
      gzhList: [],
      // 列表加载状态
      loading: false,
      // 列表查询参数
      listQuery: {
        type: 1,
        pageNumber: 1,
        pageSize: 10,
        total: 0,
        appid: "",
        openid: "",
        gzh_openid: "",
        user_name: ""
      },
      // 用户列表数据
      tableData: [],
      // 新增/编辑抽屉可见性
      dialogFormVisible: false,
      // 操作类型名称（新增/修改）
      inputTypeName: "",
      // 新增/编辑表单数据
      dialogForm: {},
      // 发送通知抽屉可见性
      drawerVisible: false,
      // 消息模版列表
      templateList: [],
      // 发送通知表单数据
      sendForm: {
        template_msg: [],
        template_msg_list: []
      },
      // 发送按钮loading状态
      sendLoading: false
    };
  },
  computed: {
    listHeader,
    ...mapState(["userInfo", "filterStoreList"]),
    /**
     * @description 根据appid过滤模版列表
     * @returns {Array} 过滤后的模版列表
     */
    filteredTemplateList() {
      if (!this.sendForm.appid) {
        return this.templateList;
      }
      return this.templateList.filter(
        item => item.appid === this.sendForm.appid
      );
    }
  },
  methods: {
    /**
     * @description 获取公众号列表
     */
    async getGzhList() {
      const { data, code } = await selectGzhListApi({
        pageNumber: 1,
        pageSize: 100
      });
      if (code === 200) {
        this.gzhList = data;
      }
    },

    /**
     * @description 获取消息模版列表
     */
    async getTemplateData() {
      const { data, code } = await selectTemplateApi({
        pageNumber: 1,
        pageSize: 1000
      });
      if (code === 200) {
        this.templateList = data.map(item => {
          return {
            ...item,
            name: item.template_name + "(模版ID:" + item.id + ")"
          };
        });
      }
    },

    /**
     * @description 获取用户列表数据
     */
    async getListData() {
      let listQuery = JSON.parse(JSON.stringify(this.listQuery));
      listQuery.store_id =
        listQuery.store_id?.join(",") || this.userInfo.store_id;
      this.loading = true;
      const { data, code, count } = await selectApi(listQuery);
      if (code === 200) {
        this.tableData = data;
        this.listQuery.total = count;
        setTimeout(() => {
          this.loading = false;
        }, 600);
      }
    },

    /**
     * @description 页码改变事件
     * @param {number} pageNumber - 新的页码
     */
    handleCurrentChange(pageNumber) {
      this.listQuery.pageNumber = pageNumber;
      this.getListData();
    },

    /**
     * @description 每页条数改变事件
     * @param {number} pageSize - 新的每页条数
     */
    handleSizeChange(pageSize) {
      this.listQuery.pageSize = pageSize;
      this.getListData();
    },

    /**
     * @description 搜索用户
     */
    search() {
      this.listQuery.pageNumber = 1;
      this.getListData();
    },

    /**
     * @description 新增用户
     */
    handleAdd() {
      this.dialogFormVisible = true;
      this.inputTypeName = "新增用户";
      this.dialogForm = {};
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate();
      });
    },

    /**
     * @description 编辑用户
     * @param {Object} row - 用户数据
     */
    handleEdit(row) {
      this.dialogFormVisible = true;
      this.inputTypeName = "修改用户";
      this.dialogForm = JSON.parse(JSON.stringify(row));
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate();
      });
    },

    /**
     * @description 复制gzh_openid
     * @param {Object} row - 用户数据
     */
    async handleCopy(row) {
      try {
        // 检查浏览器是否支持Clipboard API
        if (!navigator.clipboard) {
          this.$message.error("复制功能不支持");
          return;
        }

        // 复制gzh_openid到剪贴板
        await navigator.clipboard.writeText(row.gzh_openid);
        this.$message.success("复制成功");
      } catch (err) {
        this.$message.error("复制失败");
        console.error("复制失败:", err);
      }
    },

    /**
     * @description 保存用户（新增或修改）
     */
    save() {
      // 必填字段校验
      if (
        !this.dialogForm.appid ||
        !this.dialogForm.user_name ||
        !this.dialogForm.openid ||
        !this.dialogForm.gzh_openid
      ) {
        this.$message.error("请填写必填字段");
        return;
      }

      if (this.inputTypeName === "新增用户") {
        // 新增用户
        addApi({ ...this.dialogForm }).then(res => {
          if (res.code === 200) {
            this.$message.success("新增成功!");
            this.dialogFormVisible = false;
            this.getListData();
          }
        });
      } else if (this.inputTypeName === "修改用户") {
        // 修改用户
        updateApi(this.dialogForm).then(res => {
          if (res.code === 200) {
            this.$message.success("修改成功!");
            this.dialogFormVisible = false;
            this.getListData();
          }
        });
      }
    },

    /**
     * @description 删除用户
     * @param {Object} row - 用户数据
     */
    handleDelete(row) {
      this.$confirm(`此操作将永久删除'${row.user_name}'吗, 是否继续?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          deleteApi({ id: row.id }).then(res => {
            if (res.code === 200) {
              this.$message.success("删除成功!");
              this.getListData();
            }
          });
        })
        .catch(() => {});
    },

    /**
     * @description 发送通知
     * @param {Object} row - 用户数据
     */
    handleSend(row) {
      this.drawerVisible = true;
      this.sendForm = {
        appid: row.appid,
        account_name: row.account_name,
        gzh_openid: row.gzh_openid,
        template_id: "",
        template_msg: [],
        template_msg_list: []
      };
    },

    /**
     * @description 关闭发送通知抽屉
     */
    handleDrawerClose() {
      this.sendForm = {
        appid: "",
        template_msg: [],
        template_msg_list: []
      };
    },

    /**
     * @description 选择消息模版
     * @param {number} templateId - 模版ID
     */
    changeTemplate(templateId) {
      const item = this.templateList.find(item => item.id === templateId);
      if (item) {
        try {
          this.sendForm.template_msg_list = JSON.parse(item.template_msg_list);
        } catch (error) {
          this.sendForm.template_msg_list = [];
        }
      }
    },

    /**
     * @description 将字段数组转化为公众号模版格式的对象
     * @param {Array} array - 字段数组
     * @returns {Object} 转换后的对象
     */
    transformArrayToObject(array) {
      let transformed = {};
      for (let i = 0; i < array.length; i++) {
        const item = array[i];
        const { key, value } = item;
        transformed[key] = { value };
      }
      return transformed;
    },

    /**
     * @description 发送通知
     */
    sendNotification() {
      let formData = JSON.parse(JSON.stringify(this.sendForm));

      // 校验模版字段
      for (let i = 0; i < formData.template_msg_list.length; i++) {
        const item = formData.template_msg_list[i];
        if (!item.keyName || !item.key || !item.value) {
          this.$message.error("请完善模版字段");
          return;
        }
      }

      // 转换模版字段格式
      try {
        formData.template_msg = this.transformArrayToObject(
          formData.template_msg_list
        );
      } catch (error) {
        formData.template_msg = null;
      }

      // 必填字段校验
      if (
        !formData.template_id ||
        !formData.gzh_openid ||
        !formData.template_msg
      ) {
        this.$message.error("请填写必填字段");
        return;
      }

      delete formData.template_msg_list;

      // 开启loading
      this.sendLoading = true;

      // 调用发送API
      wxSendAPi(formData)
        .then(res => {
          if (res.code === 200) {
            this.$message.success("发送成功");
            this.drawerVisible = false;
          }
        })
        .catch(err => {
          console.error("发送失败:", err);
        })
        .finally(() => {
          // 关闭loading
          this.sendLoading = false;
        });
    }
  }
};
</script>

<style scoped lang="less">
.user-list-container {
  min-height: 100vh;
  // padding: 20px;
  // background: #f5f7fa;

  // 页面头部
  .page-header {
    margin-bottom: 24px;
    padding: 24px 30px;
    background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
    border-radius: 12px;
    box-shadow: 0 8px 32px rgba(67, 233, 123, 0.3);

    .page-title {
      margin: 0 0 8px 0;
      font-size: 28px;
      font-weight: 600;
      color: #fff;
      display: flex;
      align-items: center;
      gap: 12px;

      i {
        font-size: 32px;
      }
    }

    .page-desc {
      margin: 0;
      font-size: 14px;
      color: rgba(255, 255, 255, 0.9);
    }
  }

  // 筛选容器
  .filter-container {
    background: #fff;
    border-radius: 12px;
    padding: 20px 24px;
    margin-bottom: 20px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);

    /deep/ .el-form {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      margin: 0;

      .el-form-item {
        margin-top: 10px !important;
        margin-bottom: 10px !important;
      }

      .el-button {
        &.el-button--primary {
          background-color: #165dff;
          border-color: #165dff;

          &:hover,
          &:focus {
            background-color: #4080ff;
            border-color: #4080ff;
          }
        }
      }
    }
  }

  // 表格容器
  .table-container {
    background: #fff;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
    min-height: calc(100vh - 250px);

    /deep/ .el-table__empty-block {
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 400px;
      width: 100% !important;

      .el-table__empty-text {
        text-align: center;
        line-height: 1.6;
      }
    }

    .elImage {
      width: 60px;
      max-height: 60px;
      border-radius: 8px;
      border: 2px solid #f0f0f0;
    }

    .no-image {
      color: #999;
      font-size: 13px;
    }

    .code-text {
      font-family: "Courier New", monospace;
      font-size: 13px;
      color: #666;
    }

    .operation {
      display: flex;
      gap: 8px;
      flex-wrap: wrap;
    }
  }

  // 抽屉表单
  .drawer-form {
    padding: 20px 0;
  }

  // 发送表单
  .send-form {
    padding: 20px;

    .template-field {
      margin-bottom: 15px;
      padding: 15px;
      background: #f5f7fa;
      border-radius: 8px;

      .field-row {
        display: flex;
        align-items: flex-start;
        gap: 10px;
        flex-wrap: wrap;

        .field-label {
          flex-shrink: 0;
          margin-top: 5px;
        }

        .field-input {
          width: 180px;
        }

        .field-value {
          flex: 1;
          min-width: 250px;
        }
      }
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .user-list-container {
    padding: 10px;

    .page-header {
      padding: 20px;

      .page-title {
        font-size: 22px;

        i {
          font-size: 26px;
        }
      }
    }

    .filter-container {
      padding: 15px;

      /deep/ .el-form {
        .el-form-item {
          width: 100%;
          margin-bottom: 10px;

          label {
            display: block;
            margin-bottom: 5px;
          }

          .el-input {
            width: 100% !important;
          }
        }

        .el-button {
          width: 100%;
          margin-bottom: 10px;
        }
      }
    }

    .send-form {
      .template-field {
        .field-row {
          flex-direction: column;

          .field-input,
          .field-value {
            width: 100% !important;
          }
        }
      }
    }
  }
}
</style>
